import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import * as nextReducer from "containers/Next/NextReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as marketReducer from "containers/Market/MarketReducer";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";

import Transform from "components/Next/Transform/Transform";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

class TransformContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id } = this.props;

    return <Transform {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    init: (id) => dispatch(nextTransformReducer.init(id)),
    handleBack: () => dispatch(nextTransformReducer.handleBack(id)),
    handleUpdate: (hex, node) => dispatch(nextTransformReducer.handleUpdate(id, hex, node)),
    updateSelectedHex: (hex, node) => dispatch(nextTransformReducer.updateSelectedHex(id, hex, node)),
    deleteExplorationNode: (node) => dispatch(nextTransformReducer.deleteExplorationNode(id, node)),

    viewConsultants: () => dispatch(marketReducer.viewConsultants()),
    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob, ownProps)),
    updateHireConsultant: (consultantId, isHire) => dispatch(marketReducer.updateHireConsultant(consultantId, isHire)),
    assignTodo: (todo) => dispatch(nextModelsReducer.assignTodo(id, todo)),

    updateForecastPeriods: (val) => dispatch(nextReducer.updateForecastPeriods(id, Number(val)))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = nextReducer.getDatasetId(state, id);
  const projectId = nextReducer.getProjectId(state, id);

  const optimized = projectReducer.getOptimized(state, projectId);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const setup = optimized?.setup || setupReducer.getSetup(state, "new");

  return {
    id: id,
    datasetId: datasetId,
    projectId: projectId,
    runId: runId,

    isForecastProject: projectReducer.getIsForecastProject(state, projectId),

    blueprints: viewReducer.getBlueprints(state),

    optimized: projectReducer.getOptimized(state, projectId),

    dataset: homeReducer.getDataset(state, datasetId),
    isExploreReady: homeReducer.getIsExploreReady(state, datasetId),

    hexSize: nextReducer.getHexSize(state, id),
    innerHexSize: nextReducer.getInnerHexSize(state, id),

    hexMap: nextTransformReducer.getHexMap(state, id),
    actionHexMap: nextTransformReducer.getActionHexMap(state, id),
    savedHexMap: nextTransformReducer.getSavedHexMap(state, id),
    selectedHex: nextTransformReducer.getSelectedHex(state, id),

    modelCount: nextTransformReducer.getModelCount(state, id),

    projects: nextReducer.getProjectsTransformed(state, id),

    isCreating: nextTransformReducer.getIsCreating(state, id),

    setup: setup,
    isContinuous: setupReducer.getIsContinuous(state, runId),
    modelGroups: projectReducer.getModelGroups(state, projectId),

    isDatasetFetching: globalReducer.getIsDatasetFetching(state)?.[datasetId],

    forecastPeriods: nextReducer.getForecastPeriods(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TransformContainer);
